import { logError } from "Logger";
import { prepClient } from "Clients";
import { toast } from "common/components/ui";
import { FormattedMessage } from "react-intl";
import { PREP_INSTRUCTIONS_PAGE_LABELS } from "prep/create/PrepInstructions/PrepInstructions.labels";
import React from "react";
import { selectPrepJob, setPrepJob } from "prep/store";

export const createOrUpdatePrepInstructions = async (dispatch, getState): Promise<boolean> => {
  const prepJob = selectPrepJob(getState());

  try {
    if (prepJob) {
      const { dpId, note } = prepJob;
      const updatedPrepJobResponse = await prepClient.updatePrepJobNote(dpId, { note });
      dispatch(setPrepJob(updatedPrepJobResponse));
    } else {
      throw new Error("Prep job not found");
    }
    return true;
  } catch (err) {
    toast.error(<FormattedMessage {...PREP_INSTRUCTIONS_PAGE_LABELS.submitError} />);
    logError({ fn: "createOrUpdatePrepInstructions" }, err);
    return false;
  }
};
